"use client"

import { useState } from "react"

export const useMobileSearch = () => {
  const [showMobileSearch, setShowMobileSearch] = useState<boolean>(false)

  const toggleMobileSearch = () => {
    setShowMobileSearch((prev) => !prev)
  }

  const dismissMobileSearch = () => {
    setShowMobileSearch(false)
  }

  return {
    showMobileSearch,
    toggleMobileSearch,
    dismissMobileSearch,
  }
}
